module.exports = __webpack_public_path__ + "static/media/ic_general_truck_black.f4769458.svg";